// 只在已经过平台授权与筛选的位置中统计。空间索引和设备归属缓存均限于当前地图实例。
const CELL = 2
const validPoint = point => Array.isArray(point) && point.length >= 2 && Number.isFinite(point[0]) && Number.isFinite(point[1])
const key = (lng, lat) => Math.floor(lng / CELL) + ':' + Math.floor(lat / CELL)

function ringContains (ring, lng, lat) {
  let inside = false
  for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
    const a = ring[j], b = ring[i], dx = b[0] - a[0], dy = b[1] - a[1]
    if (Math.abs((lng - a[0]) * dy - (lat - a[1]) * dx) <= 1e-10 * Math.max(1, Math.abs(dx), Math.abs(dy)) &&
        lng >= Math.min(a[0], b[0]) - 1e-10 && lng <= Math.max(a[0], b[0]) + 1e-10 &&
        lat >= Math.min(a[1], b[1]) - 1e-10 && lat <= Math.max(a[1], b[1]) + 1e-10) return true
    if ((a[1] > lat) !== (b[1] > lat) && lng < dx * (lat - a[1]) / dy + a[0]) inside = !inside
  }
  return inside
}

function contains (region, lng, lat) {
  return region.polygons.some(polygon => {
    const [minLng, minLat, maxLng, maxLat] = polygon.bounds
    return lng >= minLng && lng <= maxLng && lat >= minLat && lat <= maxLat &&
      ringContains(polygon.rings[0], lng, lat) && !polygon.rings.slice(1).some(ring => ringContains(ring, lng, lat))
  })
}

function compile (feature, index) {
  const properties = feature.properties || {}, geometry = feature.geometry || {}
  if (!properties.name || !['Polygon', 'MultiPolygon'].includes(geometry.type)) return null
  const coordinates = geometry.type === 'Polygon' ? [geometry.coordinates] : geometry.coordinates
  const polygons = (coordinates || []).map(rings => {
    if (!Array.isArray(rings) || !rings.length || rings.some(ring => !Array.isArray(ring) || ring.length < 3 || !ring.every(validPoint))) return null
    const bounds = [Infinity, Infinity, -Infinity, -Infinity]
    rings[0].forEach(([lng, lat]) => {
      bounds[0] = Math.min(bounds[0], lng); bounds[1] = Math.min(bounds[1], lat)
      bounds[2] = Math.max(bounds[2], lng); bounds[3] = Math.max(bounds[3], lat)
    })
    return { rings, bounds }
  }).filter(Boolean)
  if (!polygons.length) return null
  const bounds = [Math.min(...polygons.map(p => p.bounds[0])), Math.min(...polygons.map(p => p.bounds[1])),
    Math.max(...polygons.map(p => p.bounds[2])), Math.max(...polygons.map(p => p.bounds[3]))]
  if (bounds[0] < -180 || bounds[1] < -90 || bounds[2] > 180 || bounds[3] > 90) return null
  const region = { id: String(properties.adcode || index), name: properties.name, polygons, bounds }
  // 这是统计区域的代表位置，不是设备位置；优先使用已有边界提供的中心。
  const candidates = [properties.centroid, properties.center, [(bounds[0] + bounds[2]) / 2, (bounds[1] + bounds[3]) / 2], polygons[0].rings[0][0]]
  region.anchor = candidates.find(point => validPoint(point) && contains(region, point[0], point[1])) || polygons[0].rings[0][0]
  return region
}

export function createRegionCounter (geo) {
  const regions = (geo.features || []).map(compile).filter(Boolean).sort((a, b) => a.id.localeCompare(b.id))
  const cells = new Map()
  regions.forEach(region => {
    const [minLng, minLat, maxLng, maxLat] = region.bounds
    for (let x = Math.floor(minLng / CELL); x <= Math.floor(maxLng / CELL); x++) {
      for (let y = Math.floor(minLat / CELL); y <= Math.floor(maxLat / CELL); y++) {
        const cell = x + ':' + y
        if (!cells.has(cell)) cells.set(cell, [])
        cells.get(cell).push(region)
      }
    }
  })
  let cache = new Map()
  return {
    update (rows) {
      const next = new Map(), counts = new Map()
      rows.forEach((row, index) => {
        if (!Number.isFinite(row.lng) || !Number.isFinite(row.lat) || Math.abs(row.lng) > 180 || Math.abs(row.lat) > 90) return
        const id = row.deviceId ? 'device:' + row.deviceId : 'row:' + index
        if (next.has(id)) return
        const previous = cache.get(id)
        const region = previous && previous.lng === row.lng && previous.lat === row.lat ? previous.region
          : (cells.get(key(row.lng, row.lat)) || []).find(item => contains(item, row.lng, row.lat))
        next.set(id, { lng: row.lng, lat: row.lat, region })
        if (region) counts.set(region.id, (counts.get(region.id) || 0) + 1)
      })
      cache = next
      return regions.filter(region => counts.has(region.id)).map(region => ({ regionCount: true, regionId: region.id,
        name: region.name, count: counts.get(region.id), value: counts.get(region.id), lng: region.anchor[0], lat: region.anchor[1] }))
    }
  }
}
